import {useRoutes} from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import AnonymousRoutes from "./AnonymousRoutes";

// ==============================|| ROUTING RENDER ||============================== //

export default function CPSRoutes() {
  return useRoutes([MainRoutes, AnonymousRoutes]);
}
